import { useMemo } from 'react';
import { generateHTML } from '@tiptap/core';

import {
  getExtensions,
  isRichtextEmpty,
} from 'approot/shared/richtext/richtext.utils';
import SubActivityPrint from '../sub-activity/sub-activity-print';
import { ViewProps, RICHTEXT_SETTINGS } from './discussion.constants';
import {
  InfoBoxStyleBoxSpeech,
  InfoBoxStyleThought,
} from '../info-box/info-box-view';
import {
  BORDER_STYLE_BOX,
  BORDER_STYLE_SPEECH,
  BORDER_STYLE_THOUGHT,
} from 'global/constants';
import { COLOUR_PURPLE } from 'approot/shared/colour/colour.constants';

const DiscussionPrint = ({
  id,
  properties,
  subActivityProperties,
}: ViewProps) => {
  const extensions = getExtensions(RICHTEXT_SETTINGS);
  const style = properties.style;
  const discussion = properties.discussion;
  const instructions = useMemo(
    () =>
      isRichtextEmpty(discussion.instruction)
        ? ''
        : generateHTML(discussion.instruction, extensions),
    [discussion.instruction, extensions]
  );
  return (
    <SubActivityPrint subActivityDetails={subActivityProperties}>
      {(style.border === BORDER_STYLE_SPEECH ||
        style.border === BORDER_STYLE_BOX) && (
        <InfoBoxStyleBoxSpeech
          id={id}
          style={{ ...style, baseColour: COLOUR_PURPLE.base }}
          richtext={instructions}
        />
      )}
      {style.border === BORDER_STYLE_THOUGHT && (
        <InfoBoxStyleThought
          id={id}
          style={{ ...style, baseColour: COLOUR_PURPLE.base }}
          richtext={instructions}
        />
      )}
    </SubActivityPrint>
  );
};

export default DiscussionPrint;
